import i18next from 'i18next'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { Link } from 'widgets-for-react'
import { blockInviewHandler } from '../../../../utils/inview'
import { PictureLayout } from '../../image/imageLayout'
import { RootLayout } from '../../rootLayout'
import { DishTeaserData, DishTeasersData } from './dishTeasersState'

export type DishTeaserProps = {
  teaser: DishTeaserData
  extraClasses?: string
  pageKind: PageType
}

export const DishTeaserLayout = (p: DishTeaserProps) => {
  const { Id, Path, HeaderTitle, HeaderImage } = p.teaser
  const teaserClassName =
    p.pageKind == 'home-logged-in' ? 'teaser--dish-home' : 'teaser--dish'
  const Tag = p.pageKind == 'home-logged-in' ? 'div' : 'li'
  const isProHome = p.pageKind == 'home-logged-in'
  return (
    <Tag className={`${teaserClassName} ${p.extraClasses || ''}`}>
      <Link
        to={`${
          i18next.language == 'en' ? '/en/dishes' : '/nl/gerechten'
        }${Path.toLowerCase().replace('%', '')}`}
        className="teaser__link"
      >
        <article className="teaser__inner">
          <div className="teaser__content">
            <h3
              className={`teaser__title ${isProHome ? 'title--xs' : 'text--m'}`}
            >
              {HeaderTitle}
            </h3>
          </div>

          <div className="teaser__visual fit-object">
            <PictureLayout.Img
              image={HeaderImage}
              width="290"
              height="290"
              extraClasses="teaser__image"
              lazyload
            />
          </div>
        </article>
      </Link>
    </Tag>
  )
}

export type PageType = 'overview-page' | 'search-results' | 'home-logged-in'

type DishesTeasersLayoutProps = {
  kind: PageType
  title?: string
  dishTeasers: DishTeasersData | 'loading' | 'error'
}

export const DishTeasersLayout = (p: DishesTeasersLayoutProps) => {
  const isOverviewPage = p.kind === 'overview-page'
  const isSearchResult = p.kind === 'search-results'
  return (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      className={`block block--dish-teasers dish-teasers--${
        isOverviewPage ? 'overview' : 'search-results'
      }`}
    >
      <div
        className={`block__inner${
          !isSearchResult ? ' container--m gutter--m' : ''
        }`}
      >
        {!isOverviewPage && (
          <header
            className={`block__header${
              isSearchResult ? ' block__header--search' : ''
            }`}
          >
            <h2
              className="block__title title--xs"
              dangerouslySetInnerHTML={{ __html: p.title || '' }}
            />
          </header>
        )}

        {p.dishTeasers === 'loading' ? (
          <RootLayout.Loader hasWrapper={true} showText={true} />
        ) : p.dishTeasers == 'error' ? (
          <RootLayout.LoadingFailed
            text={i18next.t('common:loadingFailed', {
              entity: i18next.t('dishes:dishesTitle_plural').toLowerCase(),
            })}
          />
        ) : p.dishTeasers.length > 0 ? (
          <div className="block__content">
            <ul className="block__list">
              {p.dishTeasers.map((teaser) => (
                <DishTeaserLayout
                  key={teaser.Id}
                  extraClasses="block__item"
                  teaser={teaser}
                  pageKind={p.kind}
                />
              ))}
            </ul>
          </div>
        ) : (
          <RootLayout.EmptyState
            text={i18next.t('common:emptyState', {
              entity: i18next.t('dishes:dishesTitle_plural').toLowerCase(),
            })}
          />
        )}
      </div>
    </InView>
  )
}
